import React from "react";
import InfoIcon from "../../Assets/images/icon-info-circle.svg";

const BreachInfoDialog = (props: any) => {
    return (
        <>
            <div className="dialog-header" style={{ display: "flex" }}>
                <div className="dialog-icon status-default" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src={InfoIcon} alt="Circle with the letter 'i' in the center, signifying information" />
                </div>
                <div className="box-title-text">
                    <h2 className="box-title breach-dialog-title">{props.title}</h2>
                </div>
            </div>
            <div className="dialog-body margin-left-s">
                <div className="row">{props.getInfo()}</div>
            </div>
            <div className="dialog-footer">
                <div className="row justify-center">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" onClick={props.closeDialog}>
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BreachInfoDialog;
